import { getResponseErrorMessage } from '@mumble/helpers';
import { computed, reactive } from 'vue';
var Alert = /** @class */ (function () {
    function Alert(fetch) {
        var _this = this;
        this.state = reactive({
            isVisible: false,
            content: '',
            type: 'error',
        });
        this.data = reactive({
            type: computed(function () { return (fetch && fetch.isError.value ? 'error' : _this.state.type); }),
            content: computed(function () {
                return fetch && fetch.isError.value
                    ? getResponseErrorMessage(fetch.error.value)
                    : _this.state.content;
            }),
            isVisible: computed(function () { return (fetch ? fetch.isError.value || _this.state.isVisible : _this.state.isVisible); }),
        });
    }
    Alert.prototype.show = function () {
        this.state.isVisible = true;
    };
    Alert.prototype.hide = function () {
        this.state.isVisible = false;
    };
    Alert.prototype.setVisibility = function (isVisible) {
        if (isVisible === void 0) { isVisible = false; }
        this.state.isVisible = isVisible;
    };
    Alert.prototype.setContent = function (content) {
        this.state.content = content;
    };
    Alert.prototype.setType = function (type) {
        this.state.type = type;
    };
    Alert.prototype.handleApiError = function (error) {
        this.state.content = error ? getResponseErrorMessage(error) : '';
        this.state.isVisible = !!error;
        this.state.type = 'error';
    };
    return Alert;
}());
export { Alert };
